module.exports = __webpack_public_path__ + "media/Images/icon-money-exchange-755345f075c2fca41edfb882d6ba8aad.svg";